import type { Bounds } from 'quill/core';
import React from 'react';
import * as styles from './PrefixInputBackground.module.scss';

const PADDINGS = {
  left: 3,
  right: 4,
  top: 3,
  bottom: 3,
};

const withPaddings = (rect: Bounds) => ({
  left: rect.left - PADDINGS.left,
  right: rect.right + PADDINGS.right,
  top: rect.top - PADDINGS.top,
  bottom: rect.bottom + PADDINGS.bottom,
  width: rect.width + PADDINGS.left + PADDINGS.right,
  height: rect.height + PADDINGS.top + PADDINGS.bottom,
});

interface SlashCommandBackgroundProps {
  clientRects: Bounds[];
}

const PrefixInputBackground = ({ clientRects }: SlashCommandBackgroundProps) =>
  clientRects.length > 0 &&
  clientRects.map(withPaddings).map((rect) => (
    <div
      aria-hidden
      data-no-print
      key={`${rect.left}-${rect.top}`}
      style={{
        left: rect.left,
        top: rect.top,
        width: rect.width,
        height: rect.height,
      }}
      className={styles.container}
    />
  ));

export default PrefixInputBackground;
